// 导入所有 goods 模块的国际化文件
import { messages as goodsMessages } from '@/lang/goods/goodsLang.js'
import { messages as chooseProductMessages } from '@/lang/goods/chooseProductLang.js'
import { messages as addChainInoutOrderMessages } from '@/lang/goods/addChainInoutOrderLang.js'
import { messages as seckillMessages } from '@/lang/goods/seckillLang.js'
import { messages as storeOrderCartDetailMessages } from '@/lang/goods/storeOrderCartDetailLang.js'
import { messages as storeOrderUpManageMessages } from '@/lang/goods/storeOrderUpManageLang.js'
import { messages as upShopHouseDetailMessages } from '@/lang/goods/upShopHouseDetailLang.js'
import { messages as upShopHouseInManageMessages } from '@/lang/goods/upShopHouseInManageLang.js'
import { messages as upShopHouseManageMessages } from '@/lang/goods/upShopHouseManageLang.js'
import { messages as userExpeditingDeliveryMessages } from '@/lang/goods/userExpeditingDeliveryLang.js'
import { messages as shopAuditMessages } from '@/lang/goods/shopAuditLang.js'
import { messages as shopCommunityMessages } from '@/lang/goods/shopCommunityLang.js'
import { messages as shopHouseMessages } from '@/lang/goods/shopHouseLang.js'
import { messages as shopReturnAddressMessages } from '@/lang/goods/shopReturnAddressLang.js'
import { messages as shopSettingMessages } from '@/lang/goods/shopSettingLang.js'
import { messages as shopVipUserAccountMessages } from '@/lang/goods/shopVipUserAccountLang.js'
import { messages as shopVisitMessages } from '@/lang/goods/shopVisitLang.js'
import { messages as smallWeChatMessages } from '@/lang/goods/smallWeChatLang.js'
import { messages as sellingCostManageMessages } from '@/lang/goods/sellingCostManageLang.js'
import { messages as shopAccountDetailManageMessages } from '@/lang/goods/shopAccountDetailManageLang.js'
import { messages as shopAccountMessages } from '@/lang/goods/shopAccountLang.js'
import { messages as shopAppraiseManageMessages } from '@/lang/goods/shopAppraiseManageLang.js'
import { messages as productStockMessages } from '@/lang/goods/productStockLang.js'
import { messages as queryStockManageMessages } from '@/lang/goods/queryStockManageLang.js'
import { messages as queryWarnStockMessages } from '@/lang/goods/queryWarnStockLang.js'
import { messages as recommendGoodsMessages } from '@/lang/goods/recommendGoodsLang.js'
import { messages as resourceSupplierMessages } from '@/lang/goods/resourceSupplierLang.js'
import { messages as salesRankingMessages } from '@/lang/goods/salesRankingLang.js'
import { messages as sellingCostDetailMessages } from '@/lang/goods/sellingCostDetailLang.js'
import { messages as productImportMessages } from '@/lang/goods/productImportLang.js'
import { messages as productLabelMessages } from '@/lang/goods/productLabelLang.js'
import { messages as productMessages } from '@/lang/goods/productLang.js'
import { messages as productPriceRuleMessages } from '@/lang/goods/productPriceRuleLang.js'
import { messages as productSpecMessages } from '@/lang/goods/productSpecLang.js'
import { messages as groupBuyProductMessages } from '@/lang/goods/groupBuyProductLang.js'
import { messages as groupBuySettingMessages } from '@/lang/goods/groupBuySettingLang.js'
import { messages as inoutOrderMessages } from '@/lang/goods/inoutOrderLang.js'
import { messages as labelMessages } from '@/lang/goods/labelLang.js'
import { messages as myHousekeepingDispatchManageMessages } from '@/lang/goods/myHousekeepingDispatchManageLang.js'
import { messages as outOrderMessages } from '@/lang/goods/outOrderLang.js'
import { messages as printSmallOrderMessages } from '@/lang/goods/printSmallOrderLang.js'
import { messages as productCategoryMessages } from '@/lang/goods/productCategoryLang.js'
import { messages as productDetailMessages } from '@/lang/goods/productDetailLang.js'
import { messages as getSalesInfoMessages } from '@/lang/goods/getSalesInfoLang.js'
import { messages as goldBusinessManageMessages } from '@/lang/goods/goldBusinessManageLang.js'
import { messages as goodCashierCategoryMessages } from '@/lang/goods/goodCashierCategoryLang.js'
import { messages as goodCashierConfirmMessages } from '@/lang/goods/goodCashierConfirmLang.js'
import { messages as goodCashierMessages } from '@/lang/goods/goodCashierLang.js'
import { messages as groupBuyBatchManageMessages } from '@/lang/goods/groupBuyBatchManageLang.js'
import { messages as groupBuyManageMessages } from '@/lang/goods/groupBuyManageLang.js'
import { messages as editProductMessages } from '@/lang/goods/editProductLang.js'
import { messages as feePrintSpecMessages } from '@/lang/goods/feePrintSpecLang.js'
import { messages as finishHousekeepingPoolMessages } from '@/lang/goods/finishHousekeepingPoolLang.js'
import { messages as getInoutInfoMessages } from '@/lang/goods/getInoutInfoLang.js'
import { messages as getInStockInfoMessages } from '@/lang/goods/getInStockInfoLang.js'
import { messages as couponShopPoolMessages } from '@/lang/goods/couponShopPoolLang.js'
import { messages as deleteProductStockMessages } from '@/lang/goods/deleteProductStockLang.js'
import { messages as deleteStoreOrderUpMessages } from '@/lang/goods/deleteStoreOrderUpLang.js'
import { messages as distributionModeMessages } from '@/lang/goods/distributionModeLang.js'
import { messages as doAllocationOrderInMessages } from '@/lang/goods/doAllocationOrderInLang.js'
import { messages as doOrderDetailInMessages } from '@/lang/goods/doOrderDetailInLang.js'
import { messages as doOrderDetailOutMessages } from '@/lang/goods/doOrderDetailOutLang.js'
import { messages as downShopHouseMessages } from '@/lang/goods/downShopHouseLang.js'
import { messages as downShopHouseOutManageMessages } from '@/lang/goods/downShopHouseOutManageLang.js'
import { messages as buyGoldSendMessages } from '@/lang/goods/buyGoldSendLang.js'
import { messages as buyGoldSendParkingMessages } from '@/lang/goods/buyGoldSendParkingLang.js'
import { messages as centralizedPurchaseMessages } from '@/lang/goods/centralizedPurchaseLang.js'
import { messages as chainInoutOrderMessages } from '@/lang/goods/chainInoutOrderLang.js'
import { messages as chainSupplierMessages } from '@/lang/goods/chainSupplierLang.js'
import { messages as chooseShopVipUserMessages } from '@/lang/goods/chooseShopVipUserLang.js'
import { messages as couponDetailMessages } from '@/lang/goods/couponDetailLang.js'
import { messages as couponShopPoolDetailMessages } from '@/lang/goods/couponShopPoolDetailLang.js'
import { messages as accountBondObjMessages } from '@/lang/goods/accountBondObjLang.js'
import { messages as accountWithdrawalApplyMessages } from '@/lang/goods/accountWithdrawalApplyLang.js'
import { messages as adminProductMessages } from '@/lang/goods/adminProductLang.js'
import { messages as allocationOrderMessages } from '@/lang/goods/allocationOrderLang.js'
import { messages as applyReturnOrderMessages } from '@/lang/goods/applyReturnOrderLang.js'
import { messages as applyReturnOrderrCartManageMessages } from '@/lang/goods/applyReturnOrderrCartManageLang.js'
import { messages as assetInventoryInStockMessages } from '@/lang/goods/assetInventoryInStockLang.js'
import { messages as assetInventoryMessages } from '@/lang/goods/assetInventoryLang.js'
import { messages as buyGoldMessages } from '@/lang/goods/buyGoldLang.js'
import { messages as accountBankMessages } from '@/lang/goods/accountBankLang.js'

// 合并所有国际化消息
export const messages = {
      en: {
    ...goodsMessages.en,
    ...chooseProductMessages.en,
    ...addChainInoutOrderMessages.en,
        ...seckillMessages.en,
        ...storeOrderCartDetailMessages.en,
        ...storeOrderUpManageMessages.en,
        ...upShopHouseDetailMessages.en,
        ...upShopHouseInManageMessages.en,
        ...upShopHouseManageMessages.en,
        ...userExpeditingDeliveryMessages.en,
        ...shopAuditMessages.en,
        ...shopCommunityMessages.en,
        ...shopHouseMessages.en,
        ...shopReturnAddressMessages.en,
        ...shopSettingMessages.en,
        ...shopVipUserAccountMessages.en,
        ...shopVisitMessages.en,
        ...smallWeChatMessages.en,
        ...sellingCostManageMessages.en,
        ...shopAccountDetailManageMessages.en,
        ...shopAccountMessages.en,
        ...shopAppraiseManageMessages.en,
        ...productStockMessages.en,
        ...queryStockManageMessages.en,
        ...queryWarnStockMessages.en,
        ...recommendGoodsMessages.en,
        ...resourceSupplierMessages.en,
        ...salesRankingMessages.en,
        ...sellingCostDetailMessages.en,
        ...productImportMessages.en,
        ...productLabelMessages.en,
        ...productMessages.en,
        ...productPriceRuleMessages.en,
        ...productSpecMessages.en,
        ...groupBuyProductMessages.en,
        ...groupBuySettingMessages.en,
        ...inoutOrderMessages.en,
        ...labelMessages.en,
        ...myHousekeepingDispatchManageMessages.en,
        ...outOrderMessages.en,
        ...printSmallOrderMessages.en,
        ...productCategoryMessages.en,
        ...productDetailMessages.en,
        ...getSalesInfoMessages.en,
        ...goldBusinessManageMessages.en,
        ...goodCashierCategoryMessages.en,
        ...goodCashierConfirmMessages.en,
        ...goodCashierMessages.en,
        ...groupBuyBatchManageMessages.en,
        ...groupBuyManageMessages.en,
        ...editProductMessages.en,
        ...feePrintSpecMessages.en,
        ...finishHousekeepingPoolMessages.en,
        ...getInoutInfoMessages.en,
        ...getInStockInfoMessages.en,
        ...couponShopPoolMessages.en,
        ...deleteProductStockMessages.en,
        ...deleteStoreOrderUpMessages.en,
        ...distributionModeMessages.en,
        ...doAllocationOrderInMessages.en,
        ...doOrderDetailInMessages.en,
        ...doOrderDetailOutMessages.en,
        ...downShopHouseMessages.en,
        ...downShopHouseOutManageMessages.en,
        ...buyGoldSendMessages.en,
        ...buyGoldSendParkingMessages.en,
        ...centralizedPurchaseMessages.en,
        ...chainInoutOrderMessages.en,
        ...chainSupplierMessages.en,
        ...chooseShopVipUserMessages.en,
        ...couponDetailMessages.en,
        ...couponShopPoolDetailMessages.en,
        ...accountBondObjMessages.en,
        ...accountWithdrawalApplyMessages.en,
        ...adminProductMessages.en,
        ...allocationOrderMessages.en,
        ...applyReturnOrderMessages.en,
        ...applyReturnOrderrCartManageMessages.en,
        ...assetInventoryInStockMessages.en,
        ...assetInventoryMessages.en,
        ...buyGoldMessages.en,
        ...accountBankMessages.en
    },
      zh: {
    ...goodsMessages.zh,
    ...chooseProductMessages.zh,
    ...addChainInoutOrderMessages.zh,
        ...seckillMessages.zh,
        ...storeOrderCartDetailMessages.zh,
        ...storeOrderUpManageMessages.zh,
        ...upShopHouseDetailMessages.zh,
        ...upShopHouseInManageMessages.zh,
        ...upShopHouseManageMessages.zh,
        ...userExpeditingDeliveryMessages.zh,
        ...shopAuditMessages.zh,
        ...shopCommunityMessages.zh,
        ...shopHouseMessages.zh,
        ...shopReturnAddressMessages.zh,
        ...shopSettingMessages.zh,
        ...shopVipUserAccountMessages.zh,
        ...shopVisitMessages.zh,
        ...smallWeChatMessages.zh,
        ...sellingCostManageMessages.zh,
        ...shopAccountDetailManageMessages.zh,
        ...shopAccountMessages.zh,
        ...shopAppraiseManageMessages.zh,
        ...productStockMessages.zh,
        ...queryStockManageMessages.zh,
        ...queryWarnStockMessages.zh,
        ...recommendGoodsMessages.zh,
        ...resourceSupplierMessages.zh,
        ...salesRankingMessages.zh,
        ...sellingCostDetailMessages.zh,
        ...productImportMessages.zh,
        ...productLabelMessages.zh,
        ...productMessages.zh,
        ...productPriceRuleMessages.zh,
        ...productSpecMessages.zh,
        ...groupBuyProductMessages.zh,
        ...groupBuySettingMessages.zh,
        ...inoutOrderMessages.zh,
        ...labelMessages.zh,
        ...myHousekeepingDispatchManageMessages.zh,
        ...outOrderMessages.zh,
        ...printSmallOrderMessages.zh,
        ...productCategoryMessages.zh,
        ...productDetailMessages.zh,
        ...getSalesInfoMessages.zh,
        ...goldBusinessManageMessages.zh,
        ...goodCashierCategoryMessages.zh,
        ...goodCashierConfirmMessages.zh,
        ...goodCashierMessages.zh,
        ...groupBuyBatchManageMessages.zh,
        ...groupBuyManageMessages.zh,
        ...editProductMessages.zh,
        ...feePrintSpecMessages.zh,
        ...finishHousekeepingPoolMessages.zh,
        ...getInoutInfoMessages.zh,
        ...getInStockInfoMessages.zh,
        ...couponShopPoolMessages.zh,
        ...deleteProductStockMessages.zh,
        ...deleteStoreOrderUpMessages.zh,
        ...distributionModeMessages.zh,
        ...doAllocationOrderInMessages.zh,
        ...doOrderDetailInMessages.zh,
        ...doOrderDetailOutMessages.zh,
        ...downShopHouseMessages.zh,
        ...downShopHouseOutManageMessages.zh,
        ...buyGoldSendMessages.zh,
        ...buyGoldSendParkingMessages.zh,
        ...centralizedPurchaseMessages.zh,
        ...chainInoutOrderMessages.zh,
        ...chainSupplierMessages.zh,
        ...chooseShopVipUserMessages.zh,
        ...couponDetailMessages.zh,
        ...couponShopPoolDetailMessages.zh,
        ...accountBondObjMessages.zh,
        ...accountWithdrawalApplyMessages.zh,
        ...adminProductMessages.zh,
        ...allocationOrderMessages.zh,
        ...applyReturnOrderMessages.zh,
        ...applyReturnOrderrCartManageMessages.zh,
        ...assetInventoryInStockMessages.zh,
        ...assetInventoryMessages.zh,
        ...buyGoldMessages.zh,
        ...accountBankMessages.zh
    }
} 